import { render } from "./SliderMultimedia.vue?vue&type=template&id=64cb12b2"
import script from "./SliderMultimedia.vue?vue&type=script&lang=js"
export * from "./SliderMultimedia.vue?vue&type=script&lang=js"

import "./SliderMultimedia.vue?vue&type=style&index=0&id=64cb12b2&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__